import { Unit } from '@elderbyte/ngx-starter'

export class Property {
  public id: string
  public kind: PropertyKind
  public type: PropertyType
  public propertyPath: string
  public values: string[] = []
  public unit: Unit
  public description: string
  public roundingMode: string
  public precision: number
  public supportsPrecision: boolean
  public defaultValue: string
}

export enum PropertyKind {
  ITEM = 'ITEM',

  PRODUCT = 'PRODUCT',

  WORK_CENTER = 'WORK_CENTER',

  WORK_STATION = 'WORK_STATION',
}

export enum PropertyType {
  VALUE = 'VALUE',

  NUMBER = 'NUMBER',

  VALUE_LIST = 'VALUE_LIST',

  QUANTITY_LIST = 'QUANTITY_LIST',

  VALUE_ENUMERATION = 'VALUE_ENUMERATION',

  QUANTITY_ENUMERATION = 'QUANTITY_ENUMERATION',

  QUANTITY = 'QUANTITY',

  BOOLEAN = 'BOOLEAN',
}
